module.exports = __webpack_public_path__ + "img/Arrow left Icon - charcoal.ca0f80df.svg";